import { InjectionToken } from "@angular/core";
import { TranslatePipe } from "src/app/app.module";
import { FormMetadataInterface } from "../interfaces/form-metadata.interface";

export const FormsMetadata: FormMetadataInterface = {
    title: TranslatePipe.transform('formMetadata.title'),
    destination: {
      fieldName: TranslatePipe.transform('formMetadata.destination.fieldName'),
      optionsArray: TranslatePipe.transform('formMetadata.destination.optionsArray'),
      defaultValue: function() {
        return this.optionsArray[0]?.displayName;
      },
    },
    origin: {
      fieldName: TranslatePipe.transform('formMetadata.origin.fieldName'),
      optionsArray: TranslatePipe.transform('formMetadata.origin.optionsArray'),
      defaultValue: function() {
        return this.optionsArray[0]?.displayName;
      },
    },
    numberOfAdults: {
      fieldName: TranslatePipe.transform('formMetadata.numberOfAdults.fieldName'),
      optionsArray: TranslatePipe.transform('formMetadata.numberOfAdults.optionsArray'),
        defaultValue: function() {
          return this.optionsArray[0]?.value;
      },
    },
    numberOfChildren: {
      fieldName: TranslatePipe.transform('formMetadata.numberOfChildren.fieldName'),
      optionsArray: TranslatePipe.transform('formMetadata.numberOfChildren.optionsArray'),
        defaultValue: function() {
          return this.optionsArray[0]?.value;
      },
    },
    numberOfRooms: {
      fieldName: TranslatePipe.transform('formMetadata.numberOfRooms.fieldName'),
      optionsArray: TranslatePipe.transform('formMetadata.numberOfRooms.optionsArray'),
        defaultValue: function() {
          return this.optionsArray[0]?.displayName;
      },
    },
    dateRange: {
      label: TranslatePipe.transform('formMetadata.dateRange.label'),
    },
    submitButton: TranslatePipe.transform('formMetadata.submitButton'),
  }
  
  export const FORMS_METADATA_CONFIG = new InjectionToken<FormMetadataInterface>('forms-metadata-config');
  